import { Checkbox } from '@chakra-ui/react';
import { useState } from 'react';
import { useField } from 'formik';

export const FormCheckbox = ({
  selected: defaultValue = false,
  fieldName,
  children,
  ...props
}) => {
  const [_field, meta, helpers] = useField(fieldName || 'defaultName'); // eslint-disable-line
  const [selected, setSelected] = useState(meta?.value);
  const { setValue } = helpers;
  const onChange = (e) => {
    const isChecked = e.target.checked;
    setSelected(isChecked);
    setValue(isChecked);
  };

  return (
    <Checkbox isChecked={selected} onChange={onChange} {...props}>
      {children}
    </Checkbox>
  );
};
